import moment from "moment"

const COMMENT_DATE_FORMAT = "YYYY-MM-DD HH:mm"

export function commentToConversation(comment) {
    const date = moment(comment.date, COMMENT_DATE_FORMAT, true)
    return {
        text: comment.text,
        sender: comment.user || null,
        responseTo: null,
        parentMessage: null,
        seenBy: [],
        files: [],
        timestamp: date.isValid() ? date.toISOString() : comment.date,
        from: 'user'
    }
}

export function migrateConversations(document, set) {
    if (Array.isArray(document.conversations) && document.conversations.length) return
    set.conversations = (document.comments || []).map(commentToConversation)
}